module.exports = __webpack_public_path__ + "media/6.bf0b95e0.mp3";